import { mapDragToSubtitlePosition } from '@/lib/preview/mapDragToSubtitlePosition';
import { resolveSubtitleDragHandleTop } from '@/lib/preview/resolveSubtitleDragHandleTop';

export interface SubtitleDragPosition {
  position: 'middle-center';
  marginVertical: number;
}

interface SubtitleDragHandleProps {
  position: string;
  marginVertical: number;
  onChange: (next: SubtitleDragPosition) => void;
}

export function SubtitleDragHandle({
  position,
  marginVertical,
  onChange,
}: SubtitleDragHandleProps) {
  return (
    <div
      data-testid="subtitle-drag-handle"
      data-layer-ui
      className="group pointer-events-auto absolute left-1/2 z-30 h-8 w-2/3 -translate-x-1/2 -translate-y-1/2 cursor-ns-resize rounded-md border border-transparent hover:border-primary/60 hover:bg-primary/10"
      style={{
        top: resolveSubtitleDragHandleTop(position, marginVertical),
      }}
      onPointerDown={(e) => {
        if (e.button !== 0) return;
        e.stopPropagation();
        e.preventDefault();
        const overlay = (e.currentTarget.parentElement as HTMLElement).getBoundingClientRect();
        let raf: number | null = null;
        let pendingY: number | null = null;
        const apply = (yFrac: number) => {
          onChange(mapDragToSubtitlePosition(yFrac));
        };
        const onMove = (ev: PointerEvent) => {
          pendingY = (ev.clientY - overlay.top) / overlay.height;
          if (raf != null) return;
          raf = requestAnimationFrame(() => {
            raf = null;
            if (pendingY != null) apply(pendingY);
          });
        };
        const onUp = () => {
          if (raf != null) {
            cancelAnimationFrame(raf);
            raf = null;
          }
          if (pendingY != null) apply(pendingY);
          window.removeEventListener('pointermove', onMove);
          window.removeEventListener('pointerup', onUp);
        };
        window.addEventListener('pointermove', onMove);
        window.addEventListener('pointerup', onUp);
      }}
    />
  );
}
